import Container from "Components/Container/Container";
import React from "react";
const Landing = ({ data }) => {
  return (
    <section className="map">
      <Container>
        <div className="lg:w-3/4 mx-auto text-white py-12 flex flex-col gap-y-6 text-lg">
          <div
            className="custom-content "
            dangerouslySetInnerHTML={{ __html: data?.description }}
          />
        </div>
      </Container>
    </section>
  );
};

export default Landing;
